// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2tI2L","col":"styles_col__1tI4i","fulfillmentStatus":"styles_fulfillmentStatus__1x15F","emailCol":"styles_emailCol__3yn6M"};